import { tns } from 'tiny-slider/src/tiny-slider';

class PostSlider {
  constructor(el) {
    this.el = el;
    this.slider = null;

    if (window.innerWidth <= 640) {
      this.initSlider();
    }

    window.addEventListener('resize', () => this.onResize());
  }

  onResize() {
    const isMobile = window.innerWidth <= 640;
    if (isMobile && !this.slider) {
      this.initSlider();
    }
  }

  initSlider() {
    this.slider = tns({
      container: this.el,
      items: 1,
      slideBy: 1,
      mode: 'carousel',
      autoplay: false,
      autoplayButtonOutput: false,
      speed: 400,
      controls: false,
      nav: true,
      navPosition: 'bottom',
      mouseDrag: true,
    });
  }
}

export default PostSlider;
